import ComplaintAdvancedView from './ComplaintAdvancedView'

export default ComplaintAdvancedView
